import axios from 'axios';
import { serviceOptions } from 'api';

export default function configureServices() {
  serviceOptions.axios = axios;
}
